import storage from 'services/storage';

export const types = {
  SET_VIEW: 'LISTS_SET_VIEW',
  SET_MODAL: 'LISTS_SET_MODAL',
  SET_ACTIVE_LIST: 'LISTS_SET_ACTIVE_LIST',
  SET_SHOW_MY_LISTS_ONLY: 'LISTS_SET_SHOW_MY_LISTS_ONLY',
  SET_INCLUDE_PAUSED_LISTS: 'LISTS_SET_INCLUDE_PAUSED_LISTS',
  SET_SELECTED_MEMBERS: 'LISTS_SET_SELECTED_MEMBERS',
  SET_PAGE_SIZE: 'LISTS_SET_PAGE_SIZE',
  SET_PAGE_NUMBER: 'LISTS_SET_PAGE_NUMBER',
  SET_SORT: 'LISTS_SET_SORT',
  SET_ADD_TO_TARGET: 'LISTS_SET_ADD_TO_TARGET',
  SET_LIST_MEMBERS: 'LISTS_SET_LIST_MEMBERS',
  SET_MEMBERS_SEARCH: 'LISTS_SET_MEMBERS_SEARCH',
  RESTORE_STATE: 'LISTS_RESTORE_STATE',
  CLEAR_SELECTED_MEMBERS: 'LISTS_CLEAR_SELECTED_MEMBERS',
  SET_EXPORT_EXTRA_PARAMS: 'LISTS_SET_EXPORT_EXTRA_PARAMS',
  SET_IS_LOADING: 'LISTS_SET_IS_LOADING',
  SET_LISTS_PAGE_SIZE: 'LISTS_SET_LISTS_PAGE_SIZE',
  SET_LISTS_PAGE_NUMBER: 'LISTS_SET_LISTS_PAGE_NUMBER',
  SET_LISTS_SORT: 'LISTS_SET_LISTS_SORT',
  SET_LISTS_SEARCH: 'LISTS_SET_LISTS_SEARCH',
  TOGGLE_LISTS: 'LISTS_SET_TOGGLE_LISTS',
  TOGGLE_MEMBERS: 'LISTS_SET_TOGGLE_MEMBERS',
  RESET_SELECTED_LISTS: 'LISTS_SET_RESET_SELECTED_LISTS',
  TOGGLE_ACTIVE_LIST: 'LISTS_TOGGLE_ACTIVE_LIST',
  SET_ONLY_ENRICHED: 'LISTS_SET_ONLY_ENRICHED',
};

const persistState = async (dispatch, getState) => {
  const state = getState();
  const toSave = JSON.parse(JSON.stringify(state)).lists;
  delete toSave.modal;
  delete toSave.organisation.listMembers;
  delete toSave.researcher.listMembers;
  delete toSave.organisation.selectedMembers.all;
  delete toSave.researcher.selectedMembers.all;
  await storage.setItem('listsV2', toSave);
};

export const setModal = modal => ({
  type: types.SET_MODAL,
  payload: { modal },
});

export const setActiveList = (
  list,
  options = { clearSelectedMembers: true }
) => async dispatch => {
  await dispatch({
    type: types.SET_ACTIVE_LIST,
    payload: { list },
  });
  if (options.clearSelectedMembers) {
    await dispatch(setSelectedMembers({ exclude: {}, include: {} }));
  }
  await dispatch(persistState);
};

export const setShowMyListsOnly = show => async dispatch => {
  dispatch({
    type: types.SET_SHOW_MY_LISTS_ONLY,
    payload: { show },
  });
  dispatch(persistState);
};

export const setIncludePausedLists = include => async dispatch => {
  dispatch({
    type: types.SET_INCLUDE_PAUSED_LISTS,
    payload: { include },
  });
  dispatch(persistState);
};

export const setOnlyEnriched = onlyEnriched => async dispatch => {
  dispatch({
    type: types.SET_ONLY_ENRICHED,
    payload: { onlyEnriched },
  });
  dispatch(persistState);
};

export const setPageSize = size => async dispatch => {
  await dispatch({
    type: types.SET_PAGE_SIZE,
    payload: { size },
  });
  await dispatch(persistState);
};

export const setPageNumber = number => async dispatch => {
  await dispatch({
    type: types.SET_PAGE_NUMBER,
    payload: { number },
  });
  await dispatch(persistState);
};

export const setSort = sortKey => async dispatch => {
  await dispatch({
    type: types.SET_SORT,
    payload: { sortKey },
  });
  await dispatch(persistState);
};

export const setMembersSearch = search => async dispatch => {
  await dispatch({
    type: types.SET_MEMBERS_SEARCH,
    payload: search,
  });
};

export const setAddToTarget = list => ({
  type: types.SET_ADD_TO_TARGET,
  payload: { list },
});

export const setListMembers = members => ({
  type: types.SET_LIST_MEMBERS,
  payload: { members },
});

export const restoreState = state => ({
  type: types.RESTORE_STATE,
  payload: state,
});

export const setSelectedMembers = selected => async dispatch => {
  await dispatch({
    type: types.SET_SELECTED_MEMBERS,
    payload: { selected },
  });
};

export const clearSelectedMembers = () => async dispatch => {
  await dispatch(setSelectedMembers({ exclude: {}, include: {} }));
};

export const setView = view => async dispatch => {
  dispatch({
    type: types.SET_VIEW,
    payload: view,
  });
  dispatch(persistState);
};

export const setExportExtraParams = params => ({
  type: types.SET_EXPORT_EXTRA_PARAMS,
  payload: params,
});

export const setIsLoading = params => ({
  type: types.SET_IS_LOADING,
  payload: params,
});

export const setListsPageSize = size => async dispatch => {
  await dispatch({
    type: types.SET_LISTS_PAGE_SIZE,
    payload: { size },
  });
  await dispatch(persistState);
};

export const setListsPageNumber = number => async dispatch => {
  await dispatch({
    type: types.SET_LISTS_PAGE_NUMBER,
    payload: { number },
  });
  await dispatch(persistState);
};

export const setListsSort = sortKey => async dispatch => {
  await dispatch({
    type: types.SET_LISTS_SORT,
    payload: { sortKey },
  });
  await dispatch(persistState);
};

export const setSearch = search => async dispatch => {
  await dispatch({
    type: types.SET_LISTS_SEARCH,
    payload: search,
  });
  await dispatch(persistState);
};

export const toggleLists = payload => async dispatch => {
  await dispatch({
    type: types.TOGGLE_LISTS,
    payload,
  });
};

export const toggleMembers = payload => async dispatch => {
  await dispatch({
    type: types.TOGGLE_MEMBERS,
    payload,
  });
};

export const resetSelectedLists = payload => async dispatch => {
  await dispatch({
    type: types.RESET_SELECTED_LISTS,
    payload,
  });
};

export const toggleActiveList = enabled => ({
  type: types.TOGGLE_ACTIVE_LIST,
  payload: enabled,
});
